import { ApiClient } from '@memoraiz/api-client';
import { SdkResourceFactory, SdkConfig } from './types';

export type Sdk<T extends Record<string, SdkResourceFactory>> = {
  [K in keyof T]: ReturnType<T[K]>;
} & { client: ApiClient };

export const Sdk = {
  from: <T extends Record<string, SdkResourceFactory>>(
    resources: T,
    config: SdkConfig
  ) => {
    const client = ApiClient.from(config);

    const sdk = { client } as Sdk<T>;

    return Object.entries(resources).reduce((carry, [key, factory]) => {
      return { ...carry, [key]: factory(client) };
    }, sdk);
  },
  fromResources: <T extends Record<string, SdkResourceFactory>>(
    resources: T
  ) => ({
    init: (config: SdkConfig) => Sdk.from(resources, config),
  }),
};
